import React from 'react';

const Links = () => (
    <div id='links'>
      <h3>My Links</h3>
      <ul>
        <li>
          <a href='https://linkedin.com/in/spencercorwin'>LinkedIn</a>
        </li>
        <li>
          <a href='https://twitter.com/spencer_corwin'>Twitter</a>
        </li>
      </ul>
    </div>
  );
  
  export default Links;
  